import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import MoreIcon from "@mui/icons-material/More";
import styles from "../../styles/Spreadsheet/Spreadsheet.module.css";
import React from "react";

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom-end">
    <div>
      <MoreIcon className={styles.moreIco} />
    </div>
  </Tooltip>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    li: {
      marginBottom: "5px",
    },
    backgroundColor: "var(--white)",
    color: "var(--black)",
    maxWidth: "max-content",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid rgba(86, 86, 86, 0.1)",
    borderRadius: "5px",
    padding: "10px",
  },
}));

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--sidebar-hover)",
    color: "var(--blue)",
    maxWidth: 450,
    fontSize: 11,
    border: "1px solid rgba(86, 86, 86, 0.1)",
    borderRadius: 5,
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
  },
});

// export const AlertTooltip = styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
// ))(({ id }) => ({
//   [`&  .${tooltipClasses.tooltip}`]: {
//     backgroundColor:  id === "failure" ? "var(--vivid-pink)" : "var(--sidebar-hover)",
//     padding: 5,
//     color: id === "failure" ? "var(--white)" : "var(--blue)",
//     maxWidth: "max-content",
//     fontSize: 11,
//     // border:  id === "failure" ? "2px solid red" : "1px solid rgba(86, 86, 86, 0.1)",
//     borderRadius: 5,
//     boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
//   },
// }));

interface CustomTooltipProps extends TooltipProps {
  offsetY?: number; 
  id?: string;     
}

export const AlertTooltip = styled(({ className, offsetY = -10, ...props }: CustomTooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    placement="bottom"
    slotProps={{
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, offsetY],
            },
          },
        ],
      },
    }}
  />
))(({ id }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: id === "failure" ? "var(--vivid-pink)" : "var(--sidebar-hover)",
    padding: 5,
    color: id === "failure" ? "var(--white)" : "var(--blue)",
    maxWidth: "max-content",
    fontSize: 11,
    borderRadius: 5,
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  },
}));